// All api calls are initialized in this component for this application
//remove unwanted and credentials of other app

module.exports = Object.freeze({
  // BASE_URL_SANDBOX: 'https://sandbox.quickvee.net/',
  // ---------------- NODE JS -------------------
  // for Testing Node js - add "homepage": "/react", in Package.json
  // BASE_URL_SANDBOX: 'https://production.quickvee.net/', // for Testing PHP
  // BASE_URL_SANDBOX: 'https://radix.quickvee.net/', // for Testing PHP
  // BASE_URL_SANDBOX: 'https://www.quickvee.net/', // for Live PHP
  //  BASE_URL_SANDBOX: 'https://uat.quickvee.net/', // for Live testing PHP

  //  BASE_URL_SANDBOX: 'http://localhost:8888/quickvee/', // for Live testing PHP
  //  BASE_URL: 'http://localhost:8888/quickvee/', // for Live testing PHP

  //BASE_URL_SANDBOX:'https://api-ci.quickvee.us/',
  // BASE_URL_SANDBOX:'  https://uat.quickvee.net/',

  // BASE_URL_SANDBOX: 'https://qa2-api.quickvee.us/',
  //BASE_URL_SANDBOX : 'https://qa2-api.quickvee.us/',

  // BASE_URL_FOR_ELASTIC_SEARCH: 'https://dev-elasticsearch.quickvee.us/',

  // BASE_URL_FOR_ELASTIC_SEARCH: 'https://qa-elasticsearch.quickvee.us/',
  // BUCKET_BASE_URL: 'https://quickvee-products.s3.us-east-1.amazonaws.com/',
  // PRODUCT_IMAGES_BASE_URL:
  //   ' https://quickvee-products.s3.us-east-1.amazonaws.com/',
  // PRODUCT_IMAGES_BASE_URL_live:
  //   'https://quickvee-live.s3.us-east-1.amazonaws.com/',
  // MERCHANT_REDIRECTION_LINK: 'https://qa1-admin.quickvee.us/login',

  // ----------------- for Dev-QA
  // BASE_URL_SANDBOX: 'https://dev-api-ci.quickvee.us/',
  // BASE_URL: 'https://dev-api-ci.quickvee.us/',
  // BASE_URL_FOR_ELASTIC_SEARCH: 'https://dev-elasticsearch.quickvee.us/',
  // PRODUCT_IMAGES_BASE_URL:
  //   'https://quickvee-products.s3.us-east-1.amazonaws.com/',
  // BUCKET_BASE_URL: 'https://quickvee-products.s3.us-east-1.amazonaws.com/',
  // // MERCHANT_REDIRECTION_LINK: 'https://qa-admin-panel.quickvee.us/login',
  // MERCHANT_REDIRECTION_LINK: 'https://dev-admin-panel.quickvee.us/',
  // USING_SANDBOX_ENVIRONMENT: 1, // 1 is for sandbox & 0 for Live
  // BASE_URL_NODE: 'https://dev-api-node.quickvee.us/',

  // // ----------------- for QA
  BASE_URL_SANDBOX: 'https://api-ci.quickvee-qa.com/',
  BASE_URL: 'https://api-ci.quickvee-qa.com/',
  BASE_URL_FOR_ELASTIC_SEARCH: 'https://qa-elasticsearch.quickvee.us/',
  PRODUCT_IMAGES_BASE_URL:
    'https://quickvee-products.s3.us-east-1.amazonaws.com/',
  BUCKET_BASE_URL: 'https://quickvee-products.s3.us-east-1.amazonaws.com/',
  // MERCHANT_REDIRECTION_LINK: 'https://qa-admin-panel.quickvee.us/login',
  MERCHANT_REDIRECTION_LINK: 'https://admin.quickvee-qa.com/merchants',
  // MERCHANT_REDIRECTION_LINK: 'https://backend.quickvee.com/',
  USING_SANDBOX_ENVIRONMENT: 0, // 1 is for sandbox & 0 for Live
  BASE_URL_NODE: 'https://qa-api-node.quickvee.us/',

  // ----------------- for LIVE
  // BASE_URL_SANDBOX: 'https://api-ci.quickvee.us/',
  // BASE_URL: 'https://api-ci.quickvee.us/',
  // BASE_URL_FOR_ELASTIC_SEARCH: 'https://elasticsearch.quickvee.us/',
  // PRODUCT_IMAGES_BASE_URL: 'https://quickvee-live.s3.us-east-1.amazonaws.com/',
  // BUCKET_BASE_URL: 'https://quickvee-live.s3.us-east-1.amazonaws.com/',
  // MERCHANT_REDIRECTION_LINK: 'https://www.quickvee.com/merchants/login',
  // USING_SANDBOX_ENVIRONMENT: 0, // 1 is for sandbox & 0 for Live
  // BASE_URL_NODE: 'https://api-node.quickvee.us/',

  // // ----------------- UAT SERVER
  // BASE_URL_SANDBOX: 'https://uat.quickvee.net/',
  // PRODUCT_IMAGES_BASE_URL: 'https://uat.quickvee.net/',
  // MERCHANT_REDIRECTION_LINK: 'https://testordersummary.quickvee.com/login',

  // ----------------- for testing PHP on frontend.quickvee.com with aws server (WRONG products url)
  // BASE_URL_SANDBOX: 'https://aws-php.quickvee.us/',
  // PRODUCT_IMAGES_BASE_URL:
  //   'https://quickvee-products.s3.us-east-1.amazonaws.com/',
  // BUCKET_BASE_URL: 'https://quickvee-products.s3.us-east-1.amazonaws.com/',
  // MERCHANT_REDIRECTION_LINK: 'https://qa.quickvee.us',

  IS_ELASTIC_SEARCH_ON: true,
  // Authentication all api calls
  // GOOGLE_LOGIN_CUSTOMER: 'CustomerLoginReact/google_callback',
  GOOGLE_LOGIN_CUSTOMER: 'CustomerLoginReact/google_callback_new',
  RESET_CUSTOMER_PASSWORD: 'loginController/reset_password_save',
  FORGET_CUSTOMER_PASSWORD: 'Forget_pass/reset_pass_send',

  CHANGE_PASSWORD: 'Forget_pass/reset_pass_save/',
  // LOGIN_CUSTOMER: 'loginController/login',
  // LOGIN_CUSTOMER_NEW: 'CustomerLoginReact/login',
  LOGIN_CUSTOMER_NEW: 'CustomerLoginReact/login_new',
  // REGISTER_CUSTOMER: 'loginController/register',
  // REGISTER_CUSTOMER_NEW: 'CustomerLoginReact/register',
  REGISTER_CUSTOMER_NEW: 'CustomerLoginReact/register_new',
  // REGISTER_CUSTOMER_NEW: 'CustomerLoginReact/register',

  LOGIN_MERCHANT: 'loginController/chk_merchant',
  CHECK_USERNAME_MERCHANT: 'loginController/chk_merchant',
  SHOP_BY_BRAND_PRODUCTS: 'Product_api_react/shop-by-brands-products',
  SHOP_BY_BRAND_PRODUCTS_DB: 'OnlineStoreReactNewUI/getProductsByBrandName',
  GET_NODE_WISHLIST_PRODUCTS: 'wishlist/view_wishlist_product',
  // Customer Account all api calls
  GET_CUSTOMER_ACCOUNT_INFO: 'Customer_Account/All_customer_account_detail',
  UPDATE_CUSTOMER_BASIC_INFO: 'Customer_Account/Update_customer_Accounts',
  SAVE_PAYMENT_METHOD: 'Customer_Account/save_payment_method',
  GET_PAYMENT_DETAILS: 'Customer_Account/get_payment_details',
  SET_DEFAULT_PAYMENT_METHOD: 'Customer_Account/set_default_payment_method',
  DELETE_PAYMENT_METHOD: 'Customer_Account/delete_payment_method',
  ADD_DELIVERY_ADDRESS: 'Customer_Account/update_delivery_address',
  DELETE_DELIVERY_ADDRESS: 'Customer_Account/destroyDeliveryAddress',
  UPDATE_DELIVERY_ADDRESS: 'Customer_Account/update_delivery_address',
  ACCOUNT_CHANGE_PASSWORD: 'Customer_Account/save_password',
  CROP_ID_IMAGE: 'Findstore/saveIDCardReact',
  UPDATE_BILLING_INFO: 'Customer_Account/update_Accounts_identification',
  SET_DEFAULT_ADDRESS: 'Customer_Account/set_default_addr',

  CONFIG_CAT_LIST: 'Configure_category_api/config_cat_list',
  // Order all api calls
  GET_ALL_OPEN_ORDERS: 'MyOrder_react/open',
  GET_ALL_CLOSE_ORDERS: 'MyOrder_react/close',

  // Payment all api calls

  // BOGO LIST API
  GET_ALL_BOGO_LIST: 'Bogoapi/bogo_list',
  ACTIVE_BOGO_LIST: 'Bogoapi/active_bogo_list',
  USING_ACTIVE_BOGO_LIST_API: true,

  GET_BOGO_MERCHNAT: 'OnlineStoreReactNewUI/get_merchants_with_bogo_products',
  GET_BOGO_MERCHNAT_PRODUCTS:
    'OnlineStoreReactNewUI/getBogoProductListByMerchant', // all bogo products for a specific store irrespective of deal, not to use
  GET_ALL_MERCHANTS_BOGO_DEALS: 'Bogo_deal/all_merchant_bogo_deal', // all merchants - all bogo deals
  // GET_ALL_MERCHANTS_BOGO_DEALS: 'OnlineStoreReactNewUI/all_merchant_bogo_deal', // all merchants - all bogo deals
  GET_SINGLE_MERCHANT_ALL_BOGO_DEALS: 'Bogo_deal/single_merchant_deals', // single merchant - all bogo deals
  GET_SINGLE_BOGO_DEAL_ALL_PRODUCTS: 'Bogo_deal/all_product_with_bogo', // single bogo deal -  all products included in it

  // MIX AND MATCH PRICING DEALS LIST API
  MIX_AND_MATCH_PRICING_DEALS: 'Mix_match_pricing_api/mix_match_pricing_list',
  GET_ALL_MERCHANTS_MIX_MATCH_DEALS:
    'OnlineStoreReactNewUI/get_all_merchants_with_mix_and_match_products', // all merchants - all mix match deals
  GET_SINGLE_MERCHANT_ALL_MIX_MATCH_DEALS:
    'OnlineStoreReactNewUI/get_mix_and_match_products_by_merchant', // single merchant - all mix match deals
  GET_SINGLE_MIX_MATCH_DEAL_ALL_PRODUCTS: 'Bogo_deal/all_mix_match_product', // single imx match deal -  all products included in it

  // PRODUCT & CATEGORY DISCOUNTS API's
  GET_PRODUCT_CATEGORY_DISCOUNTS:
    'Product_category_discount/get_discounts_list',

  //Single Store all api calls
  GET_SINGLE_STORE_DATA: 'Findstore/merchant',
  GET_SINGLE_STORE_DATA_NEW: 'FindstoreReact/merchant_store_and_category',
  GET_SINGLE_STORE_PRODUCT_DATA: 'FindstoreReact/product_data',
  // for elastic
  GET_SINGLE_STORE_PRODUCT_DATA_ELASTIC: 'Product_api_react/merchant-products',
  GET_SINGLE_STORE_PRODUCT_OFFERS_DATA: 'FindstoreReact/offers_products',
  GET_SINGLE_STORE_PRODUCT_OFFERS_DATA_ELASTIC:
    'Product_api_react/offers-products',
  GET_SINGLE_STORE_DATA_NEW_ELASTIC:
    'FindstoreReact/merchant_categories-and-store',
  GET_SINGLE_STORE_DATA_NEW_WITH_TIME: 'FindstoreReact/store_with_time',

  // Wishlist all api calls
  GET_WISHLIST_PRODUCTS: 'FindstoreReact/listwishlist',
  ADD_TO_WISHLIST: 'FindstoreReact/savewishlist',
  DELETE_TO_WISHLIST: 'FindstoreReact/deleteWishlistAjax',

  // Single Product all api calls
  GET_SINGLE_PRODUCT: 'Findstore/SingleProduct',
  GET_SINGLE_PRODUCT_NEW: 'FindstoreReact/single_product',
  GET_FEATURED_PRODUCTS: 'FindstoreReact/get_featured_product',
  GET_HIGHEST_SELLING_PRODUCTS: 'FindstoreReact/get_highest_selling',

  // GET ALL VARIENT DATA IN CART
  // GET_VARIENT_DATA: 'Findstore/chk_variant',
  GET_VARIENTS_DETAIL: 'FindstoreReact/getVarientDetails',
  GET_VARIANT_PRODUCT_QUANTITY: 'FindstoreReact/checkValidQuantity',

  // GET ALL STORES DETAIL
  GET_ALL_STORES: 'FindstoreReact/GetAllDefaultsAndStores',

  // GET ALL STATES LIST
  GET_ALL_STATE: 'FindstoreReact/getstatelist',

  // GET HOME PAGE DATA
  GET_HOME_STORES_AND_CATEGORIES: 'home_react',

  GET_SINGLE_CATEGORY_SEARCH_DATA: 'OnlineStoreReactNewUI/browseCategories',
  UPDATE_PAYMENT_BILLING_INFO: 'Customer_Account/updateBillingAddress',

  // GET ALL STORE CREDIT HISTORY LIST
  GET_ALL_STORE_CREDIT_HISTORY: 'Lp_sc_api/store_credit_history',
  // GET_ALL_STORE_CREDIT_HISTORY_UP:
  //   'OnlineStoreReactNewUI/store_credit_history_updated',
  GET_ALL_STORE_CREDIT_HISTORY_UP:
    'Available_balance_history_api/store_credit_history',

  // GET ALL LOYALTY POINT HISTORY LIST
  GET_ALL_LOYALTY_POINT_HISTORY: 'Lp_sc_api/loyalty_program_history',
  // GET_ALL_LOYALTY_POINT_HISTORY_UP:
  //   'OnlineStoreReactNewUI/loyalty_program_history_updated',
  GET_ALL_LOYALTY_POINT_HISTORY_UP:
    'Available_balance_history_api/loyalty_points_history',

  // LOYALTY CREDIT HISTORY LIST
  LOYALTY_CREDIT_HISTORY_LIST: 'Available_balance_history_api/store_lp_list',
  LOYALTY_CREDIT_HISTORY_COUNT: 'Available_balance_history_api/store_lp_list',

  // GET_ORDER_SUMMERY_DETAILS:'MyOrder/details',
  GET_ORDER_SUMMERY_DETAILS: 'Orders/order_details',
  PAYMENT_MAIL_SMS: 'orders/payment_mail_sms',

  // STORE_CREDIT_HISTORY_LIST
  STORE_CREDIT_HISTORY: 'Available_balance_history_api/store_sc_list',

  //  COUPON DETAIL
  GET_COUPON_DETAIL: 'FindstoreReact/check_coupon',
  GET_ALL_COUPON_LIST: 'FindstoreReact/coupon_list',
  GET_ALL_COUPON_LIST_SHOW_ONLINE: 'OnlineStoreReactNewUI/coupon_list',

  // PAYMENT PAGE
  GET_TAX_DETAIL: 'FindstoreReact/tax_list',
  GET_DATE_TIME: 'FindstoreReact/get_date_times',
  CHECK_ADDRESS_IN_RANGE: 'FindstoreReact/check_address',
  GET_DELIVERY_QUOTE: 'Process_order_online/getDeliveryQuote',
  LOGIN_WITH_GUESTS: 'CustomerLoginReact/register',

  // CART PRODUCT API
  GET_ALL_CART_PRODUCT: 'FindstoreReact/getProductById',

  // PAYMENT API
  // SAVE_ORDER: 'FindstoreReact/saveOrder',
  SAVE_ORDER: 'Process_order_online/saveOrder',
  GET_ALL_USER_CARDS: 'FindstoreReact/getcardlist',
  DELETE_CARD: 'FindstoreReact/deleteSavedCard',
  LP_SC_PAYMENT: 'FindstoreReact/get_lp_sc_data',
  USED_LP_POINTS: 'FindstoreReact/calculate_loyality_points',

  // BEFORE PLACING ORDER, VALIDATE PRODUCTS
  VALIDATE_PRODUCTS: 'FindstoreReact/verify_cart_quantity',
  VALIDATE_PRODUCTS_ORDER_METHOD: 'FindstoreReact/validateProductOrderMethod',

  // GET MERCHANT STORE PRODUCTS USING SEARCH BAR
  SEARCH_PRODUCTS: 'FindstoreReact/getSearchProduct',
  STORE_NEAR_YOU: 'OnlineStoreReactNewUI/shopByStore',
  NEW_ARRIVAL_NEAR_YOU: 'OnlineStoreReactNewUI/shopByNewArrival',
  SHOP_BY_BEST_SELLER: 'OnlineStoreReactNewUI/shopByBestSellers',
  SHOP_BY_CUSTOM_CATEGORIES: 'OnlineStoreReactNewUI/shopByCustomCategories',
  SHOP_BY_ALL_CUSTOM_CATEGORIES:
    'OnlineStoreReactNewUI/shopByAllCustomCategories',
  SHOP_BY_BRAND: 'OnlineStoreReactNewUI/shopByBrands',
  // SHOP_BY_BRAND: 'UserController/get_brand_by_location',
  NEW_SHOP_BY_BRAND: 'Quickvee_custom_api/qc_dropdown_list',
  FULL_QC_LIST: 'Quickvee_custom_api/quickvee_custom_list',
  SET_POPULAR_PRODUCTS: 'OnlineStoreReactNewUI/shopByPopularProducts',
  SHOP_BY_OFFER_NEAR_YOU: 'OnlineStoreReactNewUI/shopByOffersNearYou',
  UPDATE_CUSTOMER_NAME: 'OnlineStoreReactNewUI/update_customer_name',
  UPDATE_CUSTOMER_PHONE: 'OnlineStoreReactNewUI/update_customer_phone',
  UPDATE_NOTIFICATION_SETTINGS:
    'NotificationSetting/updateNotificationSettings',
  GET_NOTIFICATION_SETTINGS: 'NotificationSetting/getNotificationSettings',
  GET_BANNER_ACTIVE: 'OnlineStoreReactNewUI/get_active_banners',
  GET_HOOKAH_MERCHANT_LIST: 'OnlineStoreReactNewUI/getHookahMerchantList',
  GET_CIGAR_MERCHANT_LIST: 'OnlineStoreReactNewUI/getCigarMerchantList',
  GET_CONVENIENCE_MERCHANT_LIST:
    'OnlineStoreReactNewUI/getConvenienceMerchantList',
  // ACCOUNT_CHANGE_PASSWORD: 'OnlineStoreReactNewUI/save_password',
  BUY_IT_AGAIN: 'OnlineStoreReactNewUI/buyItAgain',
  BUY_IT_AGAIN_MERCHANT: 'OnlineStoreReactNewUI/buyItAgainByMerchant',
  MIX_AND_MATCH: 'OnlineStoreReactNewUI/mix_match_pricing_list',
  WISHLIST_HOME: 'OnlineStoreReactNewUI/wishlist_home',
  UPDATE_ACCOUNT_IDENTITY:
    'OnlineStoreReactNewUI/update_Accounts_identification',
  SEARCH_STORE_AND_CATEGORY: 'merchant-collection/home-page-search',
  SEARCH_STORE_AND_CATEGORY_DB: 'OnlineStoreReactNewUI/homePageSearch',

  GET_SINGLE_CUSTOM_CATEGORY_SEARCH_DATA: 'home_react/custom-categories',
  SEARCH_PRODUCTS_ELASTIC: 'Product_api_react/get-merchant-search-products',
  SEARCH_PRODUCTS_NODE: 'FindstoreReact/search-products',
  NEWSLETTER_SUBSCRIBE: 'NewsLetter_pk/subscribe',

  // USER ID CARD POST API
  USER_ID_CARD_POST: `App/idproof_upload_new`,
  // USER_ID_CARD_POST: `App/idproof_upload`,
  GET_MIXNMATCH_MERCHNAT:
    'OnlineStoreReactNewUI/get_all_merchants_with_mix_and_match_products',
  GET_MIXNMATCH_MERCHNAT_PRODUCTS:
    'OnlineStoreReactNewUI/get_mix_and_match_products_by_merchant',
  // ------------------elastic end points
  GET_SHOP_BY_STORE: 'UserController/shopByStore',
  // GIFT_CARD_STORE: 'OnlineStoreReactNewUI/get_gift_cards_data',
  GIFT_CARD_STORE: 'Available_balance_history_api/gift_card_history',
  RELATED_PRODUCT: 'OnlineStoreReactNewUI/merchant_related_products',

  //  GIFT CARD HISTORY LIST
  GIFT_CARD_HISTORY_LIST: 'Available_balance_history_api/store_gc_list',

  //  GIFT CARD TRANSACTION HISTORY
  GIFT_CARD_TRANSACTION_LIST:
    'Available_balance_history_api/gift_card_transaction_list',

  /// Total COUNT API'S
  LOYALTY_TOTAL_COUNT: 'Available_balance_history_api/store_lp_count',
  STORE_CREDIT_TOTAL_COUNT: 'Available_balance_history_api/store_sc_count',
  GIFT_CARD_TOTAL_COUNT: 'Available_balance_history_api/store_gc_count',
  GIFT_CARD_HISTORY_TOTAL_COUNT:
    'Available_balance_history_api/gift_card_transaction_count',
  TOTAL_LOYALTY_POINTS: 'Available_balance_history_api/total_loyalty_points',

  // PRODUCT COUNT LOG
  PRODUCT_COUNT_LOG: 'product/log_product_viewed',
});
